"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var types_1 = require("CreatePageFlow/types");
var images = {
    qwilrLogo: "".concat(types_1.ASSETS_DIR, "Images/LogoColor.svg"),
    qwilrLogoShadow: "".concat(types_1.ASSETS_DIR, "icons/LogoShadow.svg"),
};
var BouncingQwilrLogo = function () {
    return (react_1.default.createElement("div", { className: "create-page-flow-bouncing-logo" },
        react_1.default.createElement("img", { className: "create-page-flow-bouncing-logo-icon", src: images.qwilrLogo }),
        react_1.default.createElement("img", { className: "create-page-flow-bouncing-logo-shadow", src: images.qwilrLogoShadow })));
};
exports.default = BouncingQwilrLogo;
